import { render, staticRenderFns } from "./File.vue?vue&type=template&id=19fdacfe&"
import script from "./File.vue?vue&type=script&setup=true&lang=js&"
export * from "./File.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports